const De = {
    CustomEvent: "ce",
    Pr: "p",
    $u: "pc",
    dc: "ca",
    Va: "i",
    qs: "ie",
    P: "cci",
    T: "ccic",
    $: "ccc",
    H: "ccd",
    Wl: "ss",
    xl: "se",
    Vi: "si",
    Li: "sc",
    Qi: "sbc",
    Ki: "sfe",
    eo: "iec",
    Su: "lr",
    ju: "uae",
    R: "ci",
    B: "cc",
    Au: "lcaa",
    qu: "lcar",
    Xn: "inc",
    Jn: "add",
    Qn: "rem",
    Hn: "set",
    Kn: "ncam",
    Cu: "sgu",
    Fr: "ffi",
  },
  Be = { Br: "feed_displayed", vc: "content_cards_displayed" };
export { De as EventTypes, Be as InternalEventTypes };
